import { createUseStyles } from 'react-jss';

const useStyle = createUseStyles({
  inputBase: {
    maxWidth: '100%',
    fontFamily: 'inherit',
    border: 'none',
    backgroundColor: 'transparent',
    outline: 'none',
    '&::-webkit-search-decoration, &::-webkit-search-results-button, &::-webkit-search-results-decoration, &::-webkit-search-cancel-button': {
      '-webkit-appearance': 'none',
    },
  },
});

export default useStyle;
